{
  "api": {
    "locationValidationTitle": "ਅਸੀਂ ਤੁਹਾਡੇ ਟਿਕਾਣੇ ਦੀ ਪੁਸ਼ਟੀ ਨਹੀਂ ਕਰ ਸਕੇ",
    "thresholdTitle": "ਚੈੱਕ-ਇਨ ਲਈ ਸਮੇਂ ਸਿਰ ਨਹੀਂ",
    "warehouseUnavailableTitle": "ਗੁਦਾਮ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
    "warehouseUnavailableMessage": "ਮੈਨੁਅਲ ਚੈੱਕ-ਇਨ ਨਾਲ ਅੱਗੇ ਵਧਣ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਸਹੂਲਤ ਦੇ ਸਟਾਫ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    "characterLimitTitle": "ਇਨਪੁੱਟ ਅੱਖਰ ਸੀਮਾ ਤੋਂ ਵੱਧ ਹੈ",
    "genericTitle": "ਚੈੱਕ-ਇਨ ਅਸਫਲ ਹੋਇਆ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "recaptchaTitle": "ਪੁਸ਼ਟੀਕਰਨ ਅਸਫਲ ਹੋਇਆ",
    "recaptchaMessage": "ਅਸੀਂ ਤੁਹਾਡੀ ਬੇਨਤੀ ਦੀ ਪੁਸ਼ਟੀ ਨਹੀਂ ਕਰ ਸਕੇ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਸਹੂਲਤ ਦੇ ਸਟਾਫ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।"
  }
}
